import { render } from "./SubscriptionPaymentView.vue?vue&type=template&id=28d16d92"
import script from "./SubscriptionPaymentView.vue?vue&type=script&lang=js"
export * from "./SubscriptionPaymentView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__